import React from "react";
import FileUploadField from "../CommonComponents/FileUploadField";

export default function BrandSection({ business, logoPreview, logoError, onNameChange, onLogoChange, onLogoUpload }) {
  return (
    <form className="flex flex-col gap-3 px-5 pb-5" onSubmit={onLogoUpload} autoComplete="off">
      <input type="text" placeholder="Business Name" className="bg-[#f6f6f8] border-none rounded-xl px-4 py-3 text-base" value={business.name} onChange={onNameChange} />
      <FileUploadField
        label="Business Logo"
        accept="image/*"
        value={business.logo}
        preview={logoPreview}
        onChange={onLogoChange}
        onRemove={() => onLogoChange({ target: { files: [] } })}
        error={logoError}
        optional={true}
      />
      <button type="submit" className="mt-2 px-5 py-2 bg-[#f1f1f4] text-gray-700 rounded-xl hover:bg-blue-50 border border-gray-200 text-base font-medium transition">Upload Logo</button>
    </form>
  );
}
